import Vue from 'vue';
import PaymentGateways from '@/plugins/graphql/queries/v2/active-payment-gateways.gql';
import { PaymentGatewayModel } from '@/helpers/entities/models/PaymentGatewayModel';
export default Vue.extend({
    apollo: {
        paymentGateways: {
            query: PaymentGateways,
            variables() {
                return {
                    appUuid: this.appUuid,
                };
            },
            update(data) {
                const paymentGateways = data.fetchAllActivePaymentGateways.edges;
                return paymentGateways.map((pg) => {
                    return new PaymentGatewayModel(pg.node);
                });
            },
            fetchPolicy: 'network-only',
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            paymentGateways: [],
        };
    },
    computed: {
        manualPaymentGateways() {
            return this.paymentGateways.filter((pg) => pg.manual);
        },
        thirdPartyPaymentGateways() {
            return this.paymentGateways.filter((pg) => pg.thirdPartyOnlineOption && !pg?.paymentOption?.hidden);
        },
        creditCardPaymentGateways() {
            return this.paymentGateways.filter((pg) => pg.creditCard);
        },
        providerPaymentGateways() {
            return this.paymentGateways.filter((pg) => pg.thirdPartyProvider);
        },
    },
    methods: {
        refetchPaymentGateways() {
            this.$apollo.queries.paymentGateways.refetch();
        }
    },
    render() {
        if (this.$scopedSlots.default) {
            return this.$scopedSlots.default({
                paymentGateways: this.paymentGateways,
                manualPaymentGateways: this.manualPaymentGateways,
                thirdPartyPaymentGateways: this.thirdPartyPaymentGateways.concat(this.creditCardPaymentGateways),
                providerPaymentGateways: this.providerPaymentGateways,
                refetchPaymentGateways: this.refetchPaymentGateways(),
            });
        }
    },
});
